import React, { useEffect, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import Fade from 'react-reveal/Fade'
import { Container, Row, Col } from 'react-grid-system'
import { Helmet } from 'react-helmet'

import SEO from 'src/components/seo'
import styled from 'styled-components'
import { ProjectIntroduction, ProjectIntroductionText, 
  OverviewWrap } from 'src/components/layout/layout'
import Layout from 'src/components/layout/layout'
import RelatedLinks from 'src/components/layout/furtherReading'
import CustomRow from 'src/components/core/row'



const CaptionedPhoto = styled.figure`
  flex: 1 1 0;
  min-width: 0;
  margin: 1rem;
`;

const EqualHeightImage = styled.div`
  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: 8px;
  background: white;

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }
`;

const PhotoCaption = styled.figcaption`
  margin-top: 0.6rem;
  font-size: 0.9rem;
  line-height: 1.4;
  color: #555;
  text-align: center;
`;

const PhotoWrapper = styled.div`
  margin: .5rem;
  border-radius: 8px;
  overflow: hidden;
  flex-grow: 1;
  
  img{
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`

const LinkWrapper = styled.div`
  margin-top: 1rem;
`

const AllPhotos = styled.div`
  
`
const FadeWrapper = styled.div`
  height: calc(100% - 2rem);
  // padding-top: 2rem;
  @media (min-width: 1024) {
    padding-top: 0;
    height: calc(100% - 4rem);
  }
`
const QueenElizabethMemorialPage2 = ( ) => {
  const data = useStaticQuery(graphql`
  query QueenElizabethMemorialQuery {
    allFile(
      filter: { relativeDirectory: { eq: "qem" } }
      sort: { fields: name, order: ASC }
    ) {
      nodes {
        name
        extension
        relativePath
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`)
  const img1 = data.allFile.nodes[3].childImageSharp.fluid
  const img2 = data.allFile.nodes[4].childImageSharp.fluid
  const img3 = data.allFile.nodes[1].childImageSharp.fluid
  const img4 = data.allFile.nodes[2].childImageSharp.fluid
  const img5 = data.allFile.nodes[0].childImageSharp.fluid
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setLoaded(true)
  }, [])



  return !loaded ? (
    <Layout />
  ) : (
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Martin Jennings - Queen Elizabeth Memorial</title>
        <meta
          name="description"
          content="Martin Jennings' Queen Elizabeth Memorial project."
        />
      </Helmet>
        <CustomRow>
          <OverviewWrap>
            <ProjectIntroduction>

  <ProjectIntroductionText>
    <p>
      In September 2025 the Queen Elizabeth Memorial Committee, in collaboration with Foster+Partners architects, announced the appointment of Martin Jennings to create the statue of Her Majesty Queen Elizabeth II as part of the national memorial to the late monarch. The sculpture will stand on the Mall in London at the edge of St James's Park, a short distance from Buckingham Palace. Jennings's smaller statue of Prince Philip, Duke of Edinburgh, will stand nearby.
</p>
    <p>
The sculptures will be developed over the coming months. In April 2026, to celebrate what would have been the late Queen's 100th birthday, small maquettes of the proposed artworks were shown at the British Museum and at other venues across the United Kingdom. These were part of an exhibition displaying Foster+Partners's architectural model of the whole memorial site.
The memorial models and maquettes were viewed and approved by HM King Charles and Queen Camilla as well as by other members of the royal family and the Prime Minister Keir Starmer.
    </p>

  </ProjectIntroductionText>
</ProjectIntroduction>

            
<Row>
  <CaptionedPhoto>
    <Row>
  <PhotoWrapper><Img fluid={img1}/></PhotoWrapper>
  <PhotoWrapper><Img fluid={img2}/></PhotoWrapper>
  <PhotoWrapper><Img fluid={img3}/></PhotoWrapper>
  <PhotoWrapper><Img fluid={img4}/></PhotoWrapper>
  </Row>
    <PhotoCaption>
      First sketch maquettes of the sculptures. Height 30cm.
    </PhotoCaption>
  </CaptionedPhoto>
</Row>

<Row>
<div style={{flex:"1 1 0"}}>
  <PhotoWrapper><Img fluid={img5}/></PhotoWrapper>
    <PhotoCaption>

Jennings discussing the maquettes with the King, Queen and Prime Minister.
    </PhotoCaption>
</div>
</Row>
<RelatedLinks
  title="Further reading"
  links={[
    {
      href: "https://www.gov.uk/government/news/sculptor-appointed-for-uk-national-memorial-to-queen-elizabeth-ii",
      text: "Sculptor appointed for UK national memorial to Queen Elizabeth II",
    },
    {
      href: "https://www.britishmuseum.org/exhibitions/queen-elizabeth-ii-memorial",
      text: "Queen Elizabeth II Memorial Exhibition — British Museum",
    },
    {
      href: "https://www.bbc.co.uk/news/articles/c80mnnz34y7o",
      text: "Memorial to show Queen Elizabeth II as young woman — BBC",
    },
    {
      href: "https://news.sky.com/story/sculptor-martin-jennings-chosen-to-create-statue-for-national-memorial-to-queen-elizabeth-ii-13434095",
      text: "Sculptor Martin Jennings chosen to create statue for national memorial to Queen Elizabeth II — Sky News",
    },
  ]}
/>



</OverviewWrap>
{/* <AllPhotos>
  <PhotoWrapper><Img fluid={model}/></PhotoWrapper>
</AllPhotos> */}
        </CustomRow>
    </Layout>
  )
}

export default QueenElizabethMemorialPage2
